var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_381",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29209",
    "data-name": "Group 29209",
    transform: "translate(509 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -509, -11197)",
    filter: "url(#Ellipse_381)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_381-2",
    "data-name": "Ellipse 381",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_1_",
    "data-name": "svgexport-17 (1)",
    transform: "translate(-485.017 -11180.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49895",
    "data-name": "Path 49895",
    d: "M84.55,148.231H89.7V154H84.55Z",
    transform: "translate(-74.609 -122.255)",
    fill: "#fdcc9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49896",
    "data-name": "Path 49896",
    d: "M84.551,148.91a8.643,8.643,0,0,0,5.151,1.06v-1.74H84.551Z",
    transform: "translate(-74.609 -122.254)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 2.514,
    cy: 2.868,
    rx: 2.514,
    ry: 2.868,
    transform: "translate(0 14.163)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_413",
    "data-name": "Ellipse 413",
    cx: 2.514,
    cy: 2.868,
    rx: 2.514,
    ry: 2.868,
    transform: "translate(20.007 14.163)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49897",
    "data-name": "Path 49897",
    d: "M62.161,31.5c0-4.224-3.091-7.315-9.993-7.315s-9.993,3.091-9.993,7.315S41.453,46.85,52.168,46.85,62.161,35.723,62.161,31.5Z",
    transform: "translate(-39.651 -19.946)",
    fill: "#fdcc9b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_414",
    "data-name": "Ellipse 414",
    cx: 1.082,
    cy: 1.185,
    rx: 1.082,
    ry: 1.185,
    transform: "translate(6.568 15.159)",
    fill: "#3b2519"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_415",
    "data-name": "Ellipse 415",
    cx: 0.324,
    cy: 0.324,
    rx: 0.324,
    ry: 0.324,
    transform: "translate(6.854 15.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49898",
    "data-name": "Path 49898",
    d: "M61.1,69.84c.512.256,1.333-.869,3.213.11.343.178.547-1.526-1.468-1.526C61.1,68.424,60.791,69.686,61.1,69.84Z",
    transform: "translate(-55.181 -56.433)",
    fill: "#51362a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_416",
    "data-name": "Ellipse 416",
    cx: 1.082,
    cy: 1.185,
    rx: 1.082,
    ry: 1.185,
    transform: "translate(16.436 15.159)",
    fill: "#3b2519"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    cx: 0.324,
    cy: 0.324,
    rx: 0.324,
    ry: 0.324,
    transform: "translate(16.723 15.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49899",
    "data-name": "Path 49899",
    d: "M120.742,69.84c-.512.256-1.333-.869-3.213.11-.343.178-.547-1.526,1.468-1.526C120.742,68.424,121.051,69.686,120.742,69.84Z",
    transform: "translate(-101.627 -56.433)",
    fill: "#51362a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49900",
    "data-name": "Path 49900",
    d: "M91.187,114.606c-1.069,0-1.713-.8-1.713-.412s.309,1.121,1.713,1.121,1.713-.734,1.713-1.121S92.256,114.606,91.187,114.606Zm0,3.552c-.37,0-.592-.276-.592-.142s.107.387.592.387.592-.254.592-.387S91.556,118.158,91.187,118.158Z",
    transform: "translate(-78.67 -94.095)",
    fill: "#fcbc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49901",
    "data-name": "Path 49901",
    d: "M86.47,129.138a13.976,13.976,0,0,1-2.715-.515c0,.175.49.863,2.715.863s2.715-.688,2.715-.863A13.979,13.979,0,0,1,86.47,129.138Z",
    transform: "translate(-73.953 -106.06)",
    fill: "#f7945e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49902",
    "data-name": "Path 49902",
    d: "M40.338,161.458v6.491H27.821C27.821,165.321,34.414,161.458,40.338,161.458Zm0,0v6.491H52.855C52.855,165.321,46.262,161.458,40.338,161.458Z",
    transform: "translate(-27.821 -133.164)",
    fill: "#f7941e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49903",
    "data-name": "Path 49903",
    d: "M81.36,161.458a16.394,16.394,0,0,0-3.8.477,5.091,5.091,0,0,0,3.8,1.79,5.651,5.651,0,0,0,3.936-1.758A16.477,16.477,0,0,0,81.36,161.458Z",
    transform: "translate(-68.843 -133.164)",
    fill: "#f36c21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49904",
    "data-name": "Path 49904",
    d: "M84.55,160.705a4.017,4.017,0,0,0,5.151,0A8.144,8.144,0,0,0,84.55,160.705Z",
    transform: "translate(-74.609 -132.186)",
    fill: "#fdcc9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49905",
    "data-name": "Path 49905",
    d: "M54.308,3.337S50.6-1.376,42.891.4,34.6,6.814,34.837,11.325s.85,7.157,1.581,6.83.351-3.3.428-3.992.773-3.795,5.461-3.331A19.394,19.394,0,0,0,50.945,9.6a9.714,9.714,0,0,0,2.637,2.4c2.091.769,1.405,5.9,2.225,5.9S60.644,6.042,54.308,3.337Z",
    transform: "translate(-33.575 -0.001)",
    fill: "#51362a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/Boy.6767b547ac12c3cd6a67e99d34acc55c.svg";
export { ForwardRef as ReactComponent };